import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Public|Transcript`;

const sharedProps: Pick<LocDef, 'portal' | 'shared' | 'htmlAllowed'> = {
	portal: 'CP',
	shared: false,
	htmlAllowed: false,
};

export type PublicTranscriptItemLoc = 'CPTranscriptItemANSICriteria';

export const cpPublicTranscriptItemLocs: LocDefs<PublicTranscriptItemLoc> = {
	CPTranscriptItemANSICriteria: {
		defaultValue: 'ANSI Criteria',
		description: 'Label for the ANSI criteria.',
		displayPath: `${dpRoot}|ANSI Criteria`,
		displayType: 'Label',
		feature: HubFeature.ExamComptiaAnsiCriteria,
		...sharedProps,
	},
};

export const PublicTranscriptItemLocKeys = MapLocKeys<PublicTranscriptItemLoc>(
	cpPublicTranscriptItemLocs
);
export type PublicTranscriptItemLocKey = typeof PublicTranscriptItemLocKeys;
